export const getSrcUrlFromFile = (file) => {
    if(!file){
        return;
    }
    const blob = new Blob([file], { type: file.type });
    const url = URL.createObjectURL(blob);
    return url;
};